import React from "react";
import PageTitleBanner from "../../Components/Reusable/PageTitleBanner";
import Image from "../../Components/Reusable/Image";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import DataProvider from "../../Utils/DataProvider";
import SubmitButton from "../../Components/Reusable/Buttons";
import { Link } from "react-router-dom";
import RoutesPath from "../../Utils/RoutesPath";
import { Height } from "@mui/icons-material";

const BharatSAT = () => {
  return (
    <div className="d-flex flex-column mb-auto">
      <PageTitleBanner
        PageTitle={"Bharat SAT Scholarship Examination"}
        breadCrumpPageTitle={"Bharat SAT"}
      />
      <div className="text-content-page-container d-flex flex-column align-items-center mb-0">
        <div className="bharat-sat-text-image-container d-flex flex-column gap-4 align-items-center container p-0">
          <h2 className="Heading headingColor mb-0 fw-600 text-center">
            Introducing Bharat SAT: Unlocking Potential through Education
          </h2>
          <p className="medium-text subTextColor mb-0 text-center">
            Welcome to Bharat SAT, a flagship initiative of the "Learn and
            Achieve" Edutech project, aimed at transforming the educational
            landscape of India. Bharat SAT is an All India level examination
            specially designed for 5th to 10th class, catering to students from
            5th to 10th class. This initiative stands out for its unique
            approach, combining competition and diagnosis to empower students on
            their educational journey.
          </p>
        </div>

        <div className="bharat-sat-highlights-container container p-0 row mt-2 g-4">
          <h2 className="Heading headingColor mb-2 fw-600 text-center">
            Key Highlights
          </h2>

          <BharatSATHighlightCard
            index={"01"}
            title={"All India Level Examination:"}
            description={
              "Bharat SAT is an examination that spans the entire nation, bringing students from every corner of the country together in the pursuit of knowledge and excellence."
            }
            backgroundColor={"#F6FFD2"}
          />

          <BharatSATHighlightCard
            index={"02"}
            title={"For 5th to 10th classes:"}
            description={
              "We believe that nurturing talent should begin at an early age. Bharat SAT is designed to cater to students from 5th to 10th standard, ensuring inclusivity and equal opportunity for all."
            }
            backgroundColor={"#DAFFFF"}
          />

          <BharatSATHighlightCard
            index={"03"}
            title={"Monthly Scholarships:"}
            description={
              "Bharat SAT goes beyond traditional assessments by rewarding the top-performing students at various levels, including District, State and National. Detailed information on the awards can be found separately."
            }
            backgroundColor={"#FFE8E8"}
          />

          <BharatSATHighlightCard
            index={"04"}
            title={"Competitive and Diagnostic:"}
            description={
              "Bharat SAT is not just about competition. It also serves as a diagnostic tool, helping students identify their strengths and areas for improvement. This dual nature of the examination makes it a valuable educational resource."
            }
            backgroundColor={"#FFF5DA"}
          />
        </div>
      </div>

      <div className="bharat-sat-benefits greyBackground w-100 d-flex flex-column">
        <div className="d-flex flex-column container gap-4">
          <h2 className="Heading headingColor mb-0 fw-600 text-center">
            Benefits of Bharat SAT
          </h2>
          <div className="d-flex flex-column gap-3">
            {DataProvider.bharatSatBenefits.map((benefit, index) => (
              <div key={index} className="d-flex gap-3 align-items-center">
                <Image src={SvgImages.tickMark} style={{ width: 25 }} />
                <p className="medium-text black mb-0 fw-400">{benefit.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Continue Implementation Here For Exam Fee Section */}
      <div className="bharat-sat-text-image-container d-flex flex-column gap-4 align-items-center container my-4 px-4">
        <h2 className="Heading headingColor mb-0 mt-4 fw-600 text-center">
          Exam Fee
        </h2>
        <div className="table-responsive roundedborder destopviewtable mt-0 w-100">
          <table className="table table-striped mb-0 ">
            <thead>
              <tr>
                <th></th>
                <th className="Sub-Heading fw-600 whiteOnly">Standard 5</th>
                <th className="Sub-Heading fw-600 whiteOnly">Standard 6</th>
                <th className="Sub-Heading fw-600 whiteOnly">Standard 7</th>
                <th className="Sub-Heading fw-600 whiteOnly">Standard 8</th>
                <th className="Sub-Heading fw-600 whiteOnly">Standard 9</th>
                <th className="Sub-Heading fw-600 whiteOnly">Standard 10</th>
              </tr>
            </thead>
            <tbody className="Exam-container">
              <tr>
                <td className="large-text fw-600">Exam Fees</td>
                <td className="large-text headingColor fw-600">
                  ₹ 650
                </td>
                <td className="large-text headingColor fw-600">
                  ₹ 650
                </td>
                <td className="large-text headingColor fw-600">
                  ₹ 850
                </td>
                <td className="large-text headingColor fw-600">
                  ₹ 850
                </td>
                <td className="large-text headingColor fw-600">
                  ₹ 950
                </td>
                <td className="large-text headingColor fw-600">
                  ₹ 950
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="table-responsive roundedborder Responsive-exam-fee-table mt-0 w-100">
          <table className="table table-striped mb-0">
            <thead>
              <tr>
                <th></th>
                <td className="Sub-Heading fw-600 black">Exam Fees</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th className="Sub-Heading fw-600 whiteOnly">Standard 5</th>
                <td className="Sub-Heading headingColor fw-600">₹ 650</td>
              </tr>
              <tr>
                <th className="Sub-Heading fw-600 whiteOnly">Standard 6</th>
                <td className="Sub-Heading headingColor fw-600">₹ 650</td>
              </tr>
              <tr>
                <th className="Sub-Heading fw-600 whiteOnly">Standard 7</th>
                <td className="Sub-Heading headingColor fw-600">₹ 850</td>
              </tr>
              <tr>
                <th className="Sub-Heading fw-600 whiteOnly">Standard 8</th>
                <td className="Sub-Heading headingColor fw-600">₹ 850</td>
              </tr>
              <tr>
                <th className="Sub-Heading fw-600 whiteOnly">Standard 9</th>
                <td className="Sub-Heading headingColor fw-600">₹ 950</td>
              </tr>
              <tr>
                <th className="Sub-Heading fw-600 whiteOnly">Standard 10</th>
                <td className="Sub-Heading headingColor fw-600">₹ 950</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="bharat-sat-mobile-image px-4 mt-3">
        <Image className="w-100 mt-3" src={PngImages.bharatSatMobile} />
      </div>

      <div className="bharat-sat-desktop-image container px-5 mt-5">
        <Image className="w-100" src={PngImages.bharatSatDesktop} />
      </div>

      <div className="container my-4 text-content-page-container px-4">
        <div className="student-registrationbharatsat">
          <div className="d-flex w-100 responsive-student-registration">
            <div className="d-flex align-items-end">
              <Image
                className="Student-reg-image"
                src={PngImages.bharatSATStudentRegistration}
                style={{ height: 250 }}
              />
              <Image
                className="Student-reg-image-mobileview pt-4"
                src={PngImages.studentregistrationmobile}
              />
            </div>
            <div className="d-flex flex-column justify-content-center gap-3 p-4">
              <p className="medium-text fw-500 text-center mb-0">
                Join us in this remarkable journey of knowledge, competition,
                and self-improvement with Bharat SAT. Together, we are shaping a
                brighter future for India's young minds. Discover your
                potential, compete, and succeed with Bharat SAT.
              </p>
              <div className="d-flex justify-content-center ">
                <Link to={RoutesPath.studentRegistration}>
                  <SubmitButton title={"Student Registration"} />
                </Link>
              </div>
            </div>
            <div className=" d-flex justify-content-end align-item-start">
              <Image
                className="Student-reg-image-two"
                src={SvgImages.bharatSATStudentBackIllustration}
                style={{ height: "50%" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BharatSAT;

function BharatSATHighlightCard({ title, description, backgroundColor, index }) {
  return (
    <div className="col-md-6">
      <div
        className="bharat-sat-text-content-card"
        style={{ backgroundColor: backgroundColor }}
      >
        <h3 className="large-text fw-600 darkBlueColor mb-0"><span className="Heading">{index}</span>. {title}</h3>
        <p className="medium-text fw-400 black mb-0 mt-2">{description}</p>
      </div>
    </div>
  );
}
